module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1221.e00aec53.png";